import { render, staticRenderFns } from "./ProdLog.vue?vue&type=template&id=1730700e&scoped=true"
import script from "./ProdLog.vue?vue&type=script&lang=js"
export * from "./ProdLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1730700e",
  null
  
)

export default component.exports